import { render, staticRenderFns } from "./Parents.html?vue&type=template&id=313feb98&scoped=true&external"
import script from "./Parents.js?vue&type=script&lang=js&external"
export * from "./Parents.js?vue&type=script&lang=js&external"
import style0 from "./Parents.vue?vue&type=style&index=0&id=313feb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313feb98",
  null
  
)

export default component.exports